import { SystemRoutePath } from 'applications/GSP/shared/constants/router/routePaths';
import { UserRole } from 'applications/GSP/shared/types';

export const ROLE_PERMISSIONS_BY_SYSTEM_ROUTE: Readonly<
  Record<string, UserRole[]>
> = {
  [SystemRoutePath.PrivacyNotice]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
    UserRole.NonTeachingStaff,
  ],
  [SystemRoutePath.CookiesPolicy]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
    UserRole.NonTeachingStaff,
  ],
  [SystemRoutePath.TermsOfUse]: [
    UserRole.Admin,
    UserRole.Staff,
    UserRole.Parent,
    UserRole.Student,
    UserRole.NonTeachingStaff,
  ],
};
